<template>
  <div>
    <MDBModal v-model="showDialog" :centered="true" size="md">
      <MDBModalHeader>
        <MDBModalTitle>Announcements</MDBModalTitle>
      </MDBModalHeader>

      <MDBModalBody>

        <div v-for="item in announcements" :key="item.id"
          class="d-flex  bg-white rounded-5 mb-3 overflow-hidden border">
          <div v-if="item?.image_url?.sas_url"
            class="flex-shrink-0 d-flex align-items-center justify-content-center bg-primary bg-opacity-10 w-50"
            style="overflow: hidden;">
            <img :src="item.image_url.sas_url" :alt="item.title || 'Announcement Media'"
              class="w-100 h-100 object-fit-cover" loading="lazy" />
          </div>

          <div class="d-flex flex-column justify-content-between p-3 w-100">
            <div>
              <h6 class="fw-semibold mb-2 fs-5">{{ item.title }}</h6>
              <p class="text-muted small" style="white-space: pre-line;">
                {{ item.message }}
              </p>
            </div>
            <small class="text-black mt-2">
              {{ formatDate(item.date_created) }}
            </small>
          </div>
        </div>
      </MDBModalBody>
    </MDBModal>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { GetAnnouncements } from "@/services/Announcement";
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-vue-ui-kit";
import { isVVV } from "../helpers/siteIdentifier";

const showDialog = ref(false);
const announcements = ref([]);
const formattedTeamName = isVVV() ? "vvv" : "cs";

onMounted(async () => {
  const localStorageKey = `announcementNotice_${formattedTeamName}`;
  if (localStorage.getItem(localStorageKey)) return;

  try {
    const res = await GetAnnouncements();
    if (res?.data?.length) {
      const filtered = res.data
        .filter((a) => a.is_enabled)
        .filter((a) =>
          a.dashboards?.some(
            (d) => d.navigation_tag?.toLowerCase() === formattedTeamName
          )
        );

      const sorted = filtered.sort(
        (a, b) => new Date(b.date_created) - new Date(a.date_created)
      );

      if (sorted.length > 0) {
        announcements.value = sorted;
        showDialog.value = true;
        localStorage.setItem(localStorageKey, "true");
      }
    }
  } catch (err) {
    console.error("Failed to load announcements:", err);
  }
});

function formatDate(date) {
  return new Date(date).toLocaleDateString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
</script>
